// @flow

function parseFloor(v) {
  return v === null ? 0 : v === 'st' ? 0 : Number(v);
}
function parseDoor(v) {
  return v === null ? '' : String(v);
}

function sortUnitsRaw(a, b) {
  const a1 = parseFloor(a.etage);
  const b1 = parseFloor(b.etage);
  if (a1 === b1) {
    const a2 = parseDoor(a.dør);
    const b2 = parseDoor(b.dør);
    return a2 > b2 ? 1 : a2 < b2 ? -1 : 0;
  }
  return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
}

function filterValidUnitsRaw(unit) {
  return unit.etage || unit.dør;
}

export function fetchAddress(q) {
  return fetch(`https://dawa.aws.dk/adresser/autocomplete?q=${q}&fuzzy`)
    .then(response => response.json())
    .then(body => {
      return body.slice(0, 10).map(item => ({
        label: item.tekst,
        value: item.adresse.href,
        type: 'address',
        id: item.adresse.adgangsadresseid
      }));
    });
}

export function fetchStreets(q) {
  return fetch(`https://dawa.aws.dk/vejnavne/autocomplete?q=${q}`)
    .then(response => response.json())
    .then(body => {
      return body.map(item => ({
        label: item.tekst,
        value: item.vejnavn.href,
        type: 'vejnavn',
        id: item.vejnavn.id
      }));
    });
}

export function fetchEntryPoints(q){
  return fetch(`https://dawa.aws.dk/adgangsadresser/autocomplete?q=${q}`)
    .then(response => response.json())
    .then(body => {
      return body.map(item => ({
        label: item.tekst,
        value: item.adgangsadresse.href,
        type: 'adgangsadresse',
        id: item.adgangsadresse.id
      }));
    });
}

export function fetchUnits(q) {
  return fetch(`https://dawa.aws.dk/adresser?adgangsadresseid=${q}`)
    .then(response => response.json())
    .then(data => data.filter(filterValidUnitsRaw).sort(sortUnitsRaw))
    .then(body => {
      return body.map(item => ({
        label: item.adressebetegnelse,
        value: item.href,
        type: 'unit',
        id: item.id,
        data: item
      }));
    });
}
